import { Component } from '@angular/core';
import moment from 'moment';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { BookingService } from '../../../services/booking.service';

@Component({
  selector: 'app-cancel-booking-dialog',
  templateUrl: './cancel-booking-dialog.component.html',
  styleUrl: './cancel-booking-dialog.component.scss',
  standalone: false,
})
export class CancelBookingDialogComponent {
  public reason: string = '';
  public errorMessage: string = '';
  public bookingId: number;
  public seminarStartDate: Date;
  public fullPrice: number;
  public isLoading = false;

  public selectOptions = [
    {
      label: 'Nur Bearbeitungsgebühr (bis 28 Tage vor Seminarbeginn)',
      value: 'base_cancel_fee',
    },
    {
      label: '50% des Seminarpreises (bis 8 Tage vor Seminarbeginn)',
      value: 'half_price',
    },
    {
      label: '100% des Seminarpreises (ab 7 Tage vor Seminarbeginn)',
      value: 'full_price',
    },
    {
      label: 'Kostenlos (außerordentliches Kündigungsrecht)',
      value: 'free',
    },
  ];

  public selectedOption: string = 'base_cancel_fee';

  constructor(
    private dialogRef: DynamicDialogRef,
    private config: DynamicDialogConfig,
    private bookingService: BookingService
  ) {
    this.bookingId = this.config.data.bookingId;
    this.seminarStartDate = this.config.data.seminarStartDate;
    this.fullPrice = this.config.data.fullPrice;

    if (this.seminarStartDate) {
      const diffDays = moment(this.seminarStartDate).diff(moment(), 'days');
      if (diffDays >= 28) {
        this.selectedOption = 'base_cancel_fee';
      } else if (diffDays >= 8) {
        this.selectedOption = 'half_price';
      } else {
        this.selectedOption = 'full_price';
      }
    }
  }

  public closeDialog(confirmed: boolean) {
    this.errorMessage = '';
    if (confirmed) {
      this.cancelBooking();
      return;
    }
    this.dialogRef.close({
      confirmed: false,
    });
  }

  private cancelBooking() {
    this.isLoading = true;
    this.bookingService
      .cancelBooking(this.bookingId, this.selectedOption)
      .subscribe({
        next: () => {
          this.isLoading = false;
          this.dialogRef.close({
            cancelled: true,
          });
        },
        error: error => {
          this.isLoading = false;
          this.errorMessage = 'Die Buchung konnte nicht storniert werden.';
          console.error('Error cancelling booking', error);
        },
      });
  }
}
